import {all} from "redux-saga/effects"
import {watchLoginAsync} from "./Login"

export default function* rootSaga() {
    yield all([
        watchLoginAsync(),
    ])
}